import {IVacation} from "../../../models";
import ExcelJS from "exceljs";
import imageToBase64 from "image-to-base64/browser";
import logo from "../../../assets/html/img/logo.png";
import FileSaver from "file-saver";
import {Vacations} from "../../../components/excel/Vacations";

interface IVacationsExcelProps {
    listYear: any
    vacations: IVacation[]
    translate: any
}

export const VacationsExcel = async ({listYear, vacations, translate, lang}: IVacationsExcelProps & { lang?: string }) => {

    const today = `${String(new Date().getFullYear()).slice(2, 4)}${(new Date().getMonth() + 1) < 10 ? "0" + (new Date().getMonth() + 1) : new Date().getMonth() + 1}${new Date().getDate() < 10 ? "0" + new Date().getDate() : new Date().getDate()}`
    const documentName = `${today}_${translate('vacations_admin.vacations')}${lang ? `_${lang}` : ''}`

    const workbook = new ExcelJS.Workbook();
    const worksheetTimesheet = workbook.addWorksheet(documentName);

    const base64Logo = await imageToBase64(logo) // Path to the image

    const imageId = workbook.addImage({
        base64: base64Logo,
        extension: 'png',
    });

    Vacations({worksheet: worksheetTimesheet, listYear, vacations, translate, logo: imageId})

    workbook.xlsx.writeBuffer().then(buffer => {
        const blob = new Blob([buffer], {type: 'application/octet-stream'});
        FileSaver.saveAs(blob, `${documentName}.xlsx`);
    });

}
